<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="45"
        height="54"
        viewBox="0 0 45 54"
        fill="currentColor"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 47.8262H45V53.3796H0.000434084L0 47.8262Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.3527 12.7227L2.78853 35.8905H8.26523L13.403 19.5147L15.9782 27.7017H12.647L11.3167 32.3754H17.4481L18.5537 35.8905H24.187L16.6236 12.7227H10.3527Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M32.794 12.7227H24.931V35.8905H30.3686V17.3963H32.5598C35.1021 17.3963 36.5497 18.6343 36.5497 20.8713C36.5497 23.0683 35.1021 24.3466 32.5598 24.3466H32.2077V29.02H32.794C38.6619 29.02 42.1044 26.004 42.1044 20.8713C42.1044 15.6386 38.6619 12.7227 32.794 12.7227Z"
        />
    </svg>
</template>

<script>
export default {
    name: 'ApNews'
};
</script>
